import { render, staticRenderFns } from "./couponsUse.vue?vue&type=template&id=59e7a854"
import script from "./couponsUse.vue?vue&type=script&lang=js"
export * from "./couponsUse.vue?vue&type=script&lang=js"
import style0 from "./couponsUse.vue?vue&type=style&index=0&id=59e7a854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports